import type { JSX } from 'react';

import { Card } from '@change-corgi/design-system-legacy/components/content';

import { RecentSupportersList } from './components/RecentSupportersList';

export function RecentSupporters(): JSX.Element {
	return (
		<Card
			as="section"
			backgroundColor="white"
			sx={{ border: 'unset', display: 'flex', flexDirection: 'column', borderRadius: 'big', marginBottom: '16px' }}
			data-qa="recent-supporters-module"
		>
			<RecentSupportersList />
		</Card>
	);
}
